module.exports = __webpack_public_path__ + "static/media/icon_46.dc50ba9a.svg";